import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from 'app/_guards/auth.guard';
import { SobreComponent } from './sobre.component';

const sobreRoutes: Routes = [
    { path: '', component: SobreComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(sobreRoutes)],
    exports: [RouterModule]
})
export class SobreRoutingModule {}